module.exports = "/365FarmNet/dist/fieldEnvironmentDataBarto.b1fd57711c9fc2e4f59e389762d2d31a.html";